const checkObjValuesForEmpltyStrings = (requestObject) => {
  for (let prop in requestObject) {
    if (!requestObject[prop].length) {
      return true;
    }
  }
  return false;
};
export default checkObjValuesForEmpltyStrings;